<template></template>
<script setup lang="ts">
import { useHead } from '@unhead/vue';
import type { MetaInfo } from '@/types/metaInfo';
import logger from '@/app/logger';
import { computed, toRefs } from 'vue';

const props = defineProps<{ metaInfo: MetaInfo }>();
const { metaInfo } = toRefs(props);

const scripts = computed(() => metaInfo.value.script ?? []);

scripts.value.push({
  key: 'recaptchaUrl',
  src: 'https://www.google.com/recaptcha/api.js?render=6Lcs9awZAAAAAIg5qOpFkbrTFWfXJZ-bI5TQkXbs',
  defer: true,
});

const metaObject = computed(() => {
  logger.info('Updating meta info to head: ' + metaInfo.value.title);
  return {
    title: metaInfo.value.title,
    meta: metaInfo.value.meta,
    script: scripts,
    link: metaInfo.value.link,
  };
});

useHead(metaObject);
</script>
